import * as React from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

import { cn, createComponent } from '@lair-finance/util'

const TooltipTrigger = TooltipPrimitive.Trigger

export const TooltipContentV3 = createComponent<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(
  ({ className, sideOffset = 4, ...props }, ref) => (
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'z-50 overflow-hidden animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className,
      )}
      {...props}
    />
  ),
  'TooltipContentV3',
)

export const TooltipV3 = createComponent<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  Omit<React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>, 'content'> & {
    trigger: React.ReactNode
    content: React.ReactNode
    open?: boolean
    onOpenChange?: (open: boolean) => void
    noStyle?: boolean
  }
>(({ open: externalOpen, onOpenChange, sideOffset = 10, trigger, content, side, align, noStyle, className, ...props }, ref) => {
  const [baseOpen, setBaseOpen] = React.useState(false)

  const open = externalOpen ?? baseOpen
  const setOpen = onOpenChange ?? setBaseOpen

  return (
    <TooltipPrimitive.Root open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild onClick={() => setOpen(true)}>
        {trigger}
      </TooltipTrigger>
      <TooltipContentV3
        className={cn({ 'rounded-[8px] border border-greyscale-600 bg-greyscale-700 p-[7px] typo-new-caption-2': !noStyle }, className)}
        sideOffset={sideOffset}
        side={side || 'bottom'}
        align={align}
        ref={ref}
        {...props}
      >
        {content}
      </TooltipContentV3>
    </TooltipPrimitive.Root>
  )
}, 'TooltipV3')
